import React from 'react';

const Page404 = (props) => {
    return (
        <></>
    );
}

export default Page404;